import { Spacing } from '../spacing';

export type SpacingType = Spacing | string | 0;

export const getSpacingValue = (spacing: Spacing) => parseInt(spacing.replace('px', ''), 10);

export const getSpacingStyle = (topOrAll: SpacingType, right?: SpacingType, bottom?: SpacingType, left?: SpacingType) =>
  [topOrAll, right, bottom, left].join(' ').trim();
